import React from 'react';
import styled from 'styled-components';
import { ModalBody, Modal, ModalFooter } from 'reactstrap';

export const StyledModal = styled((props) => <Modal {...props} />)`
  @media (min-width: 992px) {
    &.modal-dialog.modal-lg {
      max-width: 616px;
    }
  }

  .modal-content {
    border-radius: 16px;
    border: none;
    box-shadow: 0px 0px 32px #005999;
    --bs-modal-footer-gap: 0rem;
  }
`;

export const StyledModalHeader = styled.div`
  padding: 24px;
  color: #33373d;
  border-bottom: none !important;
`;

export const StyledModalBody = styled((props) => <ModalBody {...props} />)`
  padding: 0 24px 16px 24px !important;
  button {
    margin-bottom: 0 !important;
  }
  .justify-center {
    display: flex;
    justify-content: center;
  }
`;

export const StyledModalFooter = styled((props) => <ModalFooter {...props} />)`
  justify-content: center !important;
  border-top: none !important;
  padding: 0px 24px 24px !important;
  margin-top: 0;
  flex-direction: column;

  div {
    a.left {
      margin: 0 8px 0 0;
      padding: 0 !important;
      line-height: initial;
    }
    a.right {
      margin: 0 0 0 8px;
      padding: 0 !important;
      line-height: initial;
    }
  }
`;

export const Title = styled.h6`
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  color: #33373d;
`;

export const SubTitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
`;
